import Constant from "../utils/constant";
const BASE_PATH_WEB = "/index.php?main_page=info_check&action=change_country_currency";
function getPathByRun(isUat) {
    const host = isUat ? "" : "https://gw.lightinthebox.com";
    return `${host}${BASE_PATH_WEB}`;
}
function setSession(params) {
    const { fetchMethod = "GET", language = Constant.language, countryCode = Constant.countryCode2, currencyCode = Constant.currency } = params;
    const bashPath = getPathByRun(Constant.isUat);
    const url = `${bashPath}&language=${language}&country_code=${countryCode}&currency_code=${currencyCode}`;
    return fetch(url, {
        mode: "cors",
        method: fetchMethod,
        credentials: Constant.isUat ? "same-origin" : "include"
    }).then(response => {
        return response.json();
    });
}
export default setSession;
